import React from "react";
import SplashStyles from "./SplashStyles.module.css";
import classes from "./SplashStyles.module.css";
import Logo from "components/Logo";

function SplashScreen() {
  return (
    <div className={classes.splashWrapper}>
      <div className={SplashStyles.imgContainer}>
        <Logo smallLogo={true} />
      </div>
    </div>
  );
}

export default SplashScreen;
